export enum UserEndpoints {
    Me = '/users/me',
}
